import yup from '../yup';

// tranlate to japanese
export const updatePasswordSchema = yup.object().shape({
  currentPassword: yup.string()
    .nullable()
    .required('現在のパスワードを入力してください')
    .label('currentPassword'),
  newPassword: yup.string()
    .nullable()
    .required('新しいパスワードを入力してください')
    .min(8, 'パスワードは8文字以上で入力してください')
    .matches(/^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)[a-zA-Z\d]{8,100}$/g, 'パスワードは大文字・小文字・数字を含む必要があります')
    .label('newPassword'),
  newPasswordConfirm: yup.string()
    .nullable()
    .required('新しいパスワード確認を入力してください')
    .oneOf([yup.ref('newPassword')], 'パスワードが一致しません')
    .label('newPasswordConfirm'),
});
